import React from 'react';
import './style.css';

// Suspense fallback shown only while a lazy-loaded route chunk is still
// downloading/evaluating (Home is loaded eagerly and never suspends).
// Deliberately minimal: no layout-shifting content, respects
// prefers-reduced-motion, and doesn't block/delay the first paint since
// it only ever appears *after* navigation to a not-yet-loaded route.
const PageLoader = () => (
  <div className="page-loader" role="status" aria-live="polite">
    <span className="page-loader__spinner" aria-hidden="true" />
    <span className="page-loader__sr-text">Loading…</span>
  </div>
);

export default PageLoader;
